import { bbtNative, openWebview, closeWebview } from '@bbtfe/webview-bridge';
import queryString from '@utils/query-string';
import { history } from 'core/history';
import { lazyWeixinJsSdk } from '@utils/lazylib';
import {
  QUERY_KEY_WHITE_MAP,
  NEWVIEW_QUERY_KEY_WHITE_MAP,
  NEW_WEBVIEW_QUERY
} from './config';
import { isInMiniProgram } from './development';
import { formatUrlToObj } from './tools';
import { miniProgramNavigateTo } from './mini-program-nav';
import { gte } from '@utils/semver';
import { isIOS, isAndroid } from '@utils/device';

let isOpeningWebview = false;

/**
 * 打开新的美囤小程序 webview
 * @param {*} pathStr
 */
export const openWxappBlank = ({ url: pathStr, title, isMiniProgramPath }) => {
  const distUrlObj = formatUrlToObj(pathStr);
  const isProtocol = /^(\S)+:\/\/(\S)+/.test(distUrlObj.url);

  distUrlObj.query[NEW_WEBVIEW_QUERY] = 1;
  let url = queryString.stringifyUrl(distUrlObj);

  if (isMiniProgramPath) {
    miniProgramNavigateTo(url);
    return;
  }

  // 解析mtoapp，兼容App原生&微信小程序原生
  if (
    distUrlObj?.query?.mtoapp == 2 ||
    pathStr.indexOf('shop.meitun.com/product/detail') >= 0 ||
    pathStr.indexOf('shop.meitun-test.com/product/detail') >= 0
  ) {
    const sku = distUrlObj?.query?.pid || distUrlObj?.query?.sku || '';
    const promotionType = distUrlObj?.query?.promotionType || '';
    const promotionId = distUrlObj?.query?.promotionId || '';
    miniProgramNavigateTo(
      `/packageGoods/pages/goodsDetail/index?sku=${sku}&promotionType=${promotionType}&promotionId=${promotionId}`,
      pathStr
    );
    return;
  }

  if (!isProtocol) {
    url = `${window.location.origin}${queryString.stringifyUrl(distUrlObj)}`;
  }

  miniProgramNavigateTo(
    `/pages/webView/index?url=${encodeURIComponent(url)}`
  );
};

export const navTo = function (config = {}) {
  let {
    url = '',
    title = '',
    webviewFirst = true,
    queryKeyBlackMap = {},
    isMiniProgramPath = false,
    replace = false,
    pageTrackInfo = {},
    skipPassThrough = false
  } = config;
  if (!url) return;
  const splitedUrl = url.split('#');
  url = splitedUrl[0];
  const hash = splitedUrl[1];
  const currentUrlObj = queryString.parseUrl(window.location.href);
  const distUrlObj = queryString.parseUrl(url);
  if (webviewFirst && bbtNative.isApp()) {
    if (isOpeningWebview) return;
    isOpeningWebview = true;
    window.setTimeout(() => {
      isOpeningWebview = false;
    }, 1000);
    bbtNative.ready(() => {
      const passThrough = skipPassThrough
        ? {}
        : Object.keys(currentUrlObj.query).reduce((total = {}, item) => {
            if (NEWVIEW_QUERY_KEY_WHITE_MAP[item] && !queryKeyBlackMap[item]) {
              total[`${item}`] = currentUrlObj.query[`${item}`];
            }
            return total;
          }, {});
      distUrlObj.query = {
        ...pageTrackInfo,
        ...passThrough,
        ...distUrlObj.query
      };
      distUrlObj.query[NEW_WEBVIEW_QUERY] = 1;
      // FIX: 安卓extra_info特殊字符编解码2次
      if (!isIOS() && !gte('9.38.0')) {
        delete distUrlObj.query.extra_info;
      }
      const isFullHttp = /^(\S)+:\/\/(\S)+/.test(distUrlObj.url);
      const isProtocokLessHttp = /^\/\/(\S)+/.test(distUrlObj.url);
      if (isFullHttp) {
        if (replace && !isAndroid()) {
          window.location.replace(
            `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${hash}` : ''}`
          );
        } else {
          if (isAndroid() && replace) {
            // Android系统replace无效，通过先关闭再打开新webview实现
            setTimeout(() => {
              closeWebview();
            }, 500);
          }
          openWebview(
            title,
            `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${hash}` : ''}`
          );
        }
      } else if (isProtocokLessHttp) {
        if (replace && !isAndroid()) {
          window.location.replace(
            `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${hash}` : ''}`
          );
        } else {
          if (isAndroid() && replace) {
            // Android系统replace无效，通过先关闭再打开新webview实现
            setTimeout(() => {
              closeWebview();
            }, 500);
          }
          openWebview(
            title,
            `${window.location.protocol}${queryString.stringifyUrl(
              distUrlObj
            )}${hash ? `#${hash}` : ''}`
          );
        }
      } else {
        if (replace && !isAndroid()) {
          window.location.replace(
            `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${hash}` : ''}`
          );
        } else {
          if (isAndroid() && replace) {
            // Android系统replace无效，通过先关闭再打开新webview实现
            setTimeout(() => {
              closeWebview();
            }, 500);
          }
          openWebview(
            title,
            `${window.location.origin}${queryString.stringifyUrl(distUrlObj)}${
              hash ? `#${hash}` : ''
            }`
          );
        }
      }
    });
  } else if (webviewFirst && isInMiniProgram()) {
    openWxappBlank({ url, title, isMiniProgramPath });
  } else {
    const passThrough = skipPassThrough
      ? {}
      : Object.keys(currentUrlObj.query).reduce((total = {}, item) => {
          if (QUERY_KEY_WHITE_MAP[item] && !queryKeyBlackMap[item]) {
            total[`${item}`] = currentUrlObj.query[`${item}`];
          }
          return total;
        }, {});
    distUrlObj.query = {
      ...pageTrackInfo,
      ...passThrough,
      ...distUrlObj.query
    };
    delete distUrlObj.query[NEW_WEBVIEW_QUERY];
    const isFullHttp = /^(\S)+:\/\/(\S)+/.test(distUrlObj.url);
    const isProtocokLessHttp = /^\/\/(\S)+/.test(distUrlObj.url);
    if (isFullHttp || isProtocokLessHttp) {
      if (replace) {
        window.location.replace(
          `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${hash}` : ''}`
        );
      } else {
        window.location.href = `${queryString.stringifyUrl(distUrlObj)}${
          hash ? `#${hash}` : ''
        }`;
      }
    } else {
      if (replace) {
        history.replace(
          `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${hash}` : ''}`
        );
      } else {
        history.push(
          `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${hash}` : ''}`
        );
      }
    }
  }
};

export const navBack = function () {
  const currentUrlObj = queryString.parseUrl(window.location.href);
  if (
    bbtNative.isApp() &&
    (currentUrlObj.query[NEW_WEBVIEW_QUERY] == 1 || history.length == 1)
  ) {
    bbtNative.ready(() => {
      closeWebview();
    });
  } else if (
    isInMiniProgram() &&
    (currentUrlObj.query[NEW_WEBVIEW_QUERY] == 1 || history.length == 1)
  ) {
    lazyWeixinJsSdk().then(wx => {
      wx.miniProgram.navigateBack();
    });
  } else {
    history.goBack();
  }
};
